import { memo } from 'react';
import EventCard from './EventCard';

function SkillDisplay({ display }) {
  if (!display || typeof display !== 'object') return null;

  if (
    display.type === 'learning_events' &&
    Array.isArray(display.items) &&
    display.items.length > 0
  ) {
    const itemCount = display.items.length;
    const title = display.title || 'Learning & Events';
    const subtitle =
      typeof display.subtitle === 'string' && display.subtitle.trim()
        ? display.subtitle.trim()
        : itemCount === 1
          ? 'Top offering match from official records'
          : `Top ${itemCount} offering matches from official records`;

    return (
      <div className="mt-3 overflow-hidden rounded-[18px] border border-[#DCE7EA] bg-[linear-gradient(180deg,rgba(248,252,253,0.95)_0%,rgba(255,255,255,1)_24%)]">
        <div className="flex items-start justify-between gap-3 border-b border-[#E7EEF0] px-4 py-3 sm:px-5">
          <div className="min-w-0">
            <div className="inline-flex items-center rounded-full border border-[#BFE0E5] bg-[rgba(16,74,79,0.05)] px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-[#104A4F]">
              {title}
            </div>
            <p className="mt-1.5 text-xs leading-5 text-slate-500">{subtitle}</p>
          </div>
          <div className="rounded-full border border-[#E4E7EA] bg-white px-2.5 py-1 text-[11px] font-semibold text-slate-600">
            {itemCount} {itemCount === 1 ? 'match' : 'matches'}
          </div>
        </div>

        <div className="space-y-2.5 p-3 sm:p-4">
          {display.items.map((item, index) => (
            <EventCard key={item.id || index} event={item} />
          ))}
        </div>
      </div>
    );
  }

  return null;
}

export default memo(SkillDisplay);
